/**
 * @package samen-klimaat-actief
 *
 * Entry point for Javascript package
 */

// Common
require('./components/common/menu-controller'); // Fold out menu controller
require('./components/common/ska-embed-player');

// Logic
require('./components/logic/lunrSearch'); // Search enige

// Animation
require('./components/animation/hash-navigator'); // Hash links js scroll
// require('./components/animation/lottie-paralax'); // Lottie home page element
require('./index.lottie'); // Repsonsive lottie initializer
require('./components/animation/button-animation'); // Button hover and click animation

// Responsive
require('./components/mobile/icon-switcher'); // Mobile icon switcher

const partnerSliders = document.querySelectorAll('.partnerSlider');
if (partnerSliders) {
  import(/* webpackChunkName: 'partnerSlider' */ './components/common/partner-slider').then(
    (module) => {
      const initPartnerSlider = module.default;
      partnerSliders.forEach((slider: HTMLElement) => {
        initPartnerSlider(slider);
      });
    },
  );
}

// Initialize the application
// Start all required functions in here
function soulInit() {
  // @ts-ignore Initialize lazy loading
  new LazyLoad();

  // Check for cookie,
  // Fix for php caching
  const hasConsent = document.cookie.indexOf('cookie_consent=');
  const cookieContainer = document.getElementById('soul_cookie_notice');
  if (hasConsent !== -1 && cookieContainer) {
    cookieContainer.remove();
  }
}

// Check if polyfill loading is needed
if (
  'fetch' in window &&
  'Intl' in window &&
  'URL' in window &&
  'Map' in window &&
  'forEach' in NodeList.prototype &&
  'startsWith' in String.prototype &&
  'endsWith' in String.prototype &&
  'includes' in String.prototype &&
  'includes' in Array.prototype &&
  'assign' in Object &&
  'entries' in Object &&
  'keys' in Object
) {
  soulInit();
} else {
  // @ts-ignore Load polyfills
  import('./polyfills.ts').then(soulInit);
}
